export const Header = () => {
  return (
    <div className='header'>
      <img src='./images/logo.png' className='logo' alt='Logo' />
      <div className='header_socials_wrap'>
        <a href='https://t.me/gwean_maslinka' target='_blank' rel='noopener noreferrer'>
          <img src='./images/telegram.png' alt='Telegram' />
        </a>
        <a href='https://www.youtube.com/@glass-moon-ua' target='_blank' rel='noopener noreferrer'>
          <img src='./images/youtube.png' alt='Youtube' />
        </a>
        <a href='https://www.tiktok.com/@glass_moon_ua' target='_blank' rel='noopener noreferrer'>
          <img src='./images/tik-tok.png' alt='Tik Tok' />
        </a>
        <a href='https://instagram.com/glassmoonua?igshid=MzMyNGUyNmU2YQ==' target='_blank' rel='noopener noreferrer'>
          <img src='./images/instagram.png' alt='Instagram' />
        </a>
      </div>
    </div>
  )
}